import React from 'react'


function PolicyAndConf() {

    return (
        <>
            <div className='main-container'>
                <h1 className='home-container' style={{ color: 'white' }}>
                    Politică de Confidențialitate
                </h1>

                
                    <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 1. Ce date colectăm</strong>
                    <p style={{ color: 'white' }}>Colectăm următoarele date personale:<br />

                        -Nume<br />

                        -Adresă de email<br />

                        Acestea sunt colectate prin intermediul formularelor de înscriere disponibile pe site.</p>

                    <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 2. Scopul colectării datelor</strong>
                    <p style={{ color: 'white' }}>Folosim datele colectate pentru

                        comunicarea cu utilizatorii interesați de serviciile noastre.

                    </p>

                    <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 3. Temeiul legal</strong>
                    <p style={{ color: 'white' }}>Conform Regulamentului (UE) 2016/679 (GDPR), prelucrăm datele doar cu consimțământul explicit al utilizatorilor.
                    </p>

                    <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 4. Stocarea datelor</strong>
                    <p style={{ color: 'white' }}>Datele sunt stocate în condiții de siguranță și nu sunt partajate cu terți fără acordul tău.
                    </p>

                    <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 5. Drepturile tale</strong>
                    <p style={{ color: 'white' }}>Ai următoarele drepturi:<br />

                        Să soliciți accesul la datele tale<br />

                        Să ceri corectarea sau ștergerea datelor<br />

                        Să îți retragi consimțământul în orice moment<br />

                        Pentru orice solicitare, ne poți contacta la: <strong>infocodersro@gmail.com</strong>
                    </p>

                    <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> 6. Securitatea datelor</strong>
                    <p style={{ color: 'white' }}>Luăm măsuri tehnice și organizatorice pentru a proteja datele tale împotriva accesului neautorizat, pierderii sau distrugerii.
                    </p>

                    <strong style={{ color: 'white', background: '#696969', padding: '3px', borderRadius: '5px', letterSpacing: '0.1rem' }}> Contact</strong>
                    <p style={{ color: 'white' }}>Pentru întrebări legate de confidențialitate, ne poți scrie la: <strong>infocodersro@gmail.com</strong>
                    </p>
                
            </div>
        </>
    )
}

export default PolicyAndConf